import { Component, Inject, OnInit } from "@angular/core";
import Uppy from "@uppy/core";
import { AppDashboardOptions, AppUppy, AppUppyFile } from "common";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { DEFAULT_FILE_DIALOG_HEIGHT, DEFAULT_FILE_DIALOG_WIDTH, FILE_SIZE_50_MB, hasValue, DEFAULT_ALLOWED_FILE_EXTENSIONS } from "common";
import {
  defaultUppyDialogConfig
} from "./upload-file-dialog-improved.data";
import { DEFAULT_UPPY_FILE_DIALOG_CLASS } from "../SharedConstants";

export type UploadFileDialogRef = MatDialogRef<UploadFileDialogImprovedComponent, AppUppyFile[]>;

export interface UploadDialogData {
  maxFileCount: number;
  allowedFileTypes?: string[];
}

@Component({
    selector: "ifbp-upload-file-dialog-improved",
    templateUrl: "./upload-file-dialog-improved.component.html",
    styleUrls: ["./upload-file-dialog-improved.component.scss"],
    standalone: false
})
export class UploadFileDialogImprovedComponent implements OnInit {
  files: AppUppyFile[] = [];
  uppy: AppUppy;
  uppyDashboardOptions: AppDashboardOptions;
  allowedFileTypes: string[];

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: UploadDialogData,
    @Inject(MatDialogRef)
    private dialogRef: UploadFileDialogRef,
  ) {
    if (hasValue(this.data.allowedFileTypes)) {
      this.allowedFileTypes = this.data.allowedFileTypes;
    } else {
      this.allowedFileTypes = DEFAULT_ALLOWED_FILE_EXTENSIONS;
    }
  }

  static open(dialog: MatDialog, data: UploadDialogData): MatDialogRef<UploadFileDialogImprovedComponent, AppUppyFile[]> {
    return dialog.open<UploadFileDialogImprovedComponent, UploadDialogData, AppUppyFile[]>(UploadFileDialogImprovedComponent,
      {
        data: data,
        height: `${DEFAULT_FILE_DIALOG_HEIGHT}px`,
        width: `${DEFAULT_FILE_DIALOG_WIDTH}px`,
        panelClass: DEFAULT_UPPY_FILE_DIALOG_CLASS,
      }
    );
  }

  ngOnInit() {
    this.initUppyConfig();
  }

  private initUppyConfig() {
    this.uppy = new Uppy({
      restrictions: {
        maxNumberOfFiles: this.data.maxFileCount,
        maxFileSize: FILE_SIZE_50_MB,
        allowedFileTypes: this.allowedFileTypes,
      },
      locale: {
        strings: {
          exceedsSize:
            "The uploaded file exceeds the maximum file size (%{size}). Please reduce the size of the file and try again.",
        },
        pluralize: (n: number) => n === 1 ? 0 : 1,
      },
    });
    this.uppyDashboardOptions = {
      ...defaultUppyDialogConfig,
      height: DEFAULT_FILE_DIALOG_HEIGHT - 65, // 65px for footer
      width: DEFAULT_FILE_DIALOG_WIDTH,
    };
  }

  closeDialog() {
    this.dialogRef.close(this.uppy.getFiles() as AppUppyFile[]);
  }
}
